"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../constants");
function splitOddPath(oddPath) {
    var splitted = oddPath.split(constants_1.idPathDivider);
    var matchId = splitted[0], marketId = splitted[1], oddId = splitted[2];
    if (splitted.length !== 3 || !matchId || !marketId || !oddId) {
        return null;
    }
    return {
        matchId: matchId,
        marketId: marketId,
        oddId: oddId,
    };
}
exports.default = splitOddPath;
//# sourceMappingURL=splitOddPath.js.map